import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "revico-community-talk-reply-details-badge"
}
const _hoisted_2 = {
  key: 0,
  class: "revico-community-talk-reply-details-badge-official-fan"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Official ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Fan")
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "revico-community-talk-reply-details-badge-staff"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.isExistBadge())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" バッジによって表示を分岐 "),
        ($setup.isOfficialFan())
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
          : _createCommentVNode("v-if", true),
        ($setup.isStaff())
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Staff"))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}